import React from 'react'
import { Link } from 'react-router-dom';
import SocialsList from 'shared/SocialsList/SocialsList';
import bgImage from 'images/mercedes-amg-gtr.png'

export const SectionSocials: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center w-full h-96 py-1 overflow-hidden relative">
            <img
                className="absolute top-0 left-0 w-full h-full object-cover object-center"
                src={bgImage}
                alt="bg"
                loading="lazy"
            />
            <div className="z-10 flex flex-col items-center justify-center w-full max-w-2xl space-y-8 py-4">
                <h3 className="text-2xl font-semibold text-center uppercase dark:text-neutral-200">
                    Follow us on social media
                </h3>
                <SocialsList className="mt-10" />
                <Link
                    to={"/contact"}
                    className="bg-zinc-700 text-white p-4 rounded-3xl font-medium w-fit text-xs font-display tracking-wider uppercase" >
                    Get in touch
                </Link >
            </div>
        </div>
    );
}